// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAppState } from "@guestsupply/App/Store/Reducers";
import {
    ApiHandler,
    createHandlerChainRunner,
    Handler,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";

export type rmaReturnProductImages = {
    productImage: string | ArrayBuffer | null | undefined;
    name: string;
    productErpNumber: string;
};

type HandlerType = ApiHandler<rmaReturnProductImages & HasOnSuccess & HasOnError<boolean>>;

export const ValidateRmaProductImagesNumber: HandlerType = props => {
    const state = props.getState() as CustomAppState;
    const rmaProperties = state.xRmaReturnInformation.properties;
    const imageNumber = Object.keys(rmaProperties).filter(key => key.includes(props.parameter.productErpNumber)).length;
    if (imageNumber > 4 && props.parameter.onError) {
        const error = true;
        props.parameter.onError(error);
        return false;
    }
};

export const DispatchRmaProductImage: HandlerType = props => {
    props.dispatch({
        type: "xRmaReturnInformation/SetRmaProductImage",
        productImage: props.parameter.productImage,
        name: props.parameter.name,
    } as any);
};

const xSetRmaProductImage = createHandlerChainRunner(
    [ValidateRmaProductImagesNumber, DispatchRmaProductImage],
    "rmaProductImage",
);

export default xSetRmaProductImage;
